import { isEqual } from "lodash";
import { memo } from "react";

const ALink = memo(({ href, children, ...props }: any) => {
  if (href) {
    return (
      <a target="_blank" rel="noreferrer" {...props} href={href}>
        {children}
      </a>
    );
  }
  return <div {...props}>{children}</div>;
}, isEqual);
export default ALink;
